import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DisableRightClickService {
  constructor(@Inject(DOCUMENT) private document: Document) {}
  disableRightClick() {
    this.document.addEventListener('contextmenu', (event) =>
      event.preventDefault()
    );
    // this.document.onkeydown = function (e) {
    //   // if (e.keyCode == 123) {
    //   //   return false;
    //   // }
    //   if (e.keyCode == 17) {
    //     return false;
    //   }
    // };
  }
}
